export default "__VITE_ASSET__CZcz2XOk__"